import { object, string } from 'yup'

export default object().shape({
  mid: string().required('help-tool.support-page.create-ticket.fields.mid.validation'),
  topic: string().required('help-tool.support-page.create-ticket.fields.topic.validation'),
  subject: string().required('help-tool.support-page.create-ticket.fields.subject.validation'),
  description: string().required('help-tool.support-page.create-ticket.fields.description.validation')
})
